import { render, staticRenderFns } from "./CourseConversionStudentListNew.vue?vue&type=template&id=6331489e&scoped=true"
import script from "./CourseConversionStudentListNew.vue?vue&type=script&lang=js"
export * from "./CourseConversionStudentListNew.vue?vue&type=script&lang=js"
import style0 from "./CourseConversionStudentListNew.vue?vue&type=style&index=0&id=6331489e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6331489e",
  null
  
)

export default component.exports